import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../layouts/Layout';
import CetakLabel from '../componen/CetakLabel';

export const CetakLabelPages = () => {
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate('/', { replace: true });
  }, [isError, navigate]);

  return (
    <Layout>
      <CetakLabel />
    </Layout>
  );
};
